import { useEffect, useState } from "react";

const months = [
  "Januari",
  "Februari",
  "Mars",
  "April",
  "Maj",
  "Juni",
  "Juli",
  "Augusti",
  "September",
  "Oktober",
  "November",
  "December",
];

function useDailyTick() {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const d = new Date();
      const next = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 0, 0, 2);
      timeout = setTimeout(() => {
        setNow(new Date());
        schedule();
      }, next.getTime() - d.getTime());
    };
    schedule();
    return () => clearTimeout(timeout);
  }, []);

  return now;
}

export function useCurrentMonth() {
  const now = useDailyTick();
  return {
    month: months[now.getMonth()],
    year: now.getFullYear(),
    date: now,
  };
}

/** Datumstämpel som alltid ligger 4 dagar bakåt i tiden och uppdateras 00:00. */
export function useUpdatedStamp() {
  const now = useDailyTick();
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 4);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
